import {ONE_YEAR_MS} from '@/shared/consts/time';

import {CookieConsent} from '../types';

export function isCookieConsentExpired(
  consent: CookieConsent,
  now: number = Date.now()
): boolean {
  const {timestamp} = consent;

  if (!Number.isFinite(timestamp)) {
    return true;
  }

  return now - timestamp >= ONE_YEAR_MS;
}
